import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrPageComponent } from './pr-page/pr-page.component';
import { PrPageHeaderComponent } from './pr-page-header/pr-page-header.component';
import { PrPageBodyComponent } from './pr-page-body/pr-page-body.component';
import { PrBreadcrumbModule } from '../pr-breadcrumb/pr-breadcrumb.module';
import { PrLoaderModule } from '../pr-loader/pr-loader.module';
import { PrPageHeaderMenuComponent } from './pr-page-header-menu/pr-page-header-menu.component';
import { RouterModule } from '@angular/router';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PrPageHeaderOptiComponent } from './pr-page-header-opti/pr-page-header-opti.component';
import { PrTabsModule } from '../pr-tabs/pr-tabs.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    BsDropdownModule.forRoot(),
    PrIconModule,
    PrBreadcrumbModule,
    PrLoaderModule,
    TooltipModule.forRoot(),
    PrTabsModule,
  ],
  declarations: [
    PrPageComponent,
    PrPageHeaderComponent,
    PrPageHeaderMenuComponent,
    PrPageBodyComponent,
    PrPageHeaderOptiComponent,
  ],
  exports: [
    PrPageComponent,
    PrPageHeaderComponent,
    PrPageHeaderMenuComponent,
    PrPageBodyComponent,
    PrPageHeaderOptiComponent,
  ],
})
export class PrPageModule {}
